import { CategoryModel } from "@core/models/categories";
import { AssignCoverImageCommand, GetProductBySkuQuery, GetProductsQuery, ProductReturnModel, SkuResult, UpdateDescriptionCommand, UploadProductImagesCommand } from "@core/services/api.service";

  export class LoadProductsAction {
    static readonly type = '[Products] Load Customer Products';

    constructor(public payload: { loadProductsQuery: GetProductsQuery, updateFilters?: boolean }) { }
  }

  export class LoadProductsActionSuccessAction {
    static readonly type = '[Products] Load Customer Products Success';

    constructor(public payload: { ProductReturnModel: ProductReturnModel }) { }
  }

  export class LoadProductsActionFailAction {
    static readonly type = '[Products] Load Customer Products Fail';

    constructor(public payload: { response: string }) {}
  }
  export class GetProductBySkuAction {
    static readonly type = '[Products] Get Product Details';
    constructor(public payload: { loadProductsBySkuQuery: GetProductBySkuQuery }) { }
  }
  export class GetProductBySkuSuccessAction {
    static readonly type = '[Products] Get Product Details Success Action';
    constructor(public payload: { loadProductsBySkuQuery: GetProductBySkuQuery }) { }
}

export class GetProductBySkuFailAction {
    static readonly type = '[Products] Get Product Details Fail Action';
    constructor(public payload: { response: string }) { }
}

  //-- update brands
  export class UpdateBrandAction {
    static readonly type = '[Products] Update Brands';
  }

   //-- update category
   export class UpdateCategoriesAction {
    static readonly type = '[Products] Update Categories';
  }

   //-- select category
   export class SelectCategoryAction {
    static readonly type = '[Products] Select Category';

    constructor(public payload: { category: CategoryModel }) { }
  }

  export class SetSelectedProductById {
    static readonly type = '[Product API] Set';

    constructor(public id: number) {
    }
}

export class SetSelectedProductByValue {
    static readonly type = '[Product Page] Set';

    constructor(public product: ProductReturnModel) {
    }
}

export class AddProductToCart {
    static readonly type = '[Product] Add';

    constructor(public skuCode: ProductReturnModel) {

    }

  }
export class UpdateTotalPrice {
    static readonly type = '[Product] TotalPrice';

    constructor(public product: ProductReturnModel) {

    }

  }

export class UploadProductImagesAction {
    static readonly type = '[Product] Upload Product Images Action';

    constructor(public payload: { command: UploadProductImagesCommand }) { }
}

export class UploadProductImagesSuccessAction {
    static readonly type = '[Product]  Upload Product Images Success Action';

    constructor(public payload: { status: boolean }) { }
}

export class UploadProductImagesFailAction {
    static readonly type = '[Product]  Upload Product Images Fail Action';

    constructor(public payload: { response: boolean }) { }
}

export class AssignCoverImageAction {
    static readonly type = '[Product] Assign Cover Image Action';

    constructor(public payload: { command: AssignCoverImageCommand }) { }
}

export class AssignCoverImageSuccessAction {
    static readonly type = '[Product]  Assign Cover Image Success Action';

    constructor(public payload: { status: boolean }) { }
}

export class AssignCoverImageFailAction {
    static readonly type = '[Product]  Assign Cover Image Fail Action';

    constructor(public payload: { response: boolean }) { }
}

export class UpdateDescriptionAction {
    static readonly type = '[Product] Update Description Action';

    constructor(public payload: { command: UpdateDescriptionCommand }) { }
}

export class UpdateDescriptionSuccessAction {
    static readonly type = '[Product]  Update Description Success Action';

    constructor(public payload: { loadProductsBySkuQuery: GetProductBySkuQuery }) { }
}

export class UpdateDescriptionFailAction {
    static readonly type = '[Product]  Update Description Fail Action';

    constructor(public payload: { response: boolean }) { }
}
